import type { ModuleUpgradeOffer } from '@/common/api/models/moduleUpgradeOffer';

export const UPGRADE_OFFER_LAB_CASES = ['oral-switch', 'short', 'tallest'] as const;
export type UpgradeOfferLabCase = typeof UPGRADE_OFFER_LAB_CASES[number];

const LECTURER_HEADLINE = 'More Efficient Learning with AI Feedback & Oral Exam';
const LECTURER_NOTE = 'Receive instant, personalized AI feedback on your essays to strengthen your '
  + 'understanding as you learn. At the end of the module, demonstrate your knowledge in an oral '
  + 'exam - with the full pool of possible exam questions available in advance, so you can prepare '
  + 'with confidence. You will be graded on the oral exam.';

/** The production case from the 2026-11 report: essays to oral exam, a removed task, a long note. */
const oralSwitch: ModuleUpgradeOffer = {
  targetVersion: '1.2',
  pinnedVersion: '0.0',
  headline: LECTURER_HEADLINE,
  impactNotice: LECTURER_NOTE,
  autoPromptSuppressed: false,
  changeSummary: {
    aiTutorGainedByType: { essay: 15 },
    addedByType: { essay: 1 },
    gradeBasisBeforeByType: { essay: 17 },
    gradeBasisAfterByType: { oral_exam: 1 },
    gradeBecomesOralOnly: true,
  },
  removedTasks: [{ taskId: 'essay-old', title: 'Removed essay', hasProgress: false }],
  addedTasks: [],
};

export const UPGRADE_OFFER_LAB_FIXTURES: Record<UpgradeOfferLabCase, ModuleUpgradeOffer> = {
  'oral-switch': oralSwitch,
  short: {
    targetVersion: '2.1',
    pinnedVersion: '2.0',
    headline: '',
    impactNotice: '',
    autoPromptSuppressed: false,
    changeSummary: {
      addedByType: { activity: 1 },
      gradeBasisBeforeByType: { essay: 3 },
      gradeBasisAfterByType: { essay: 3 },
      gradeBecomesOralOnly: false,
    },
    removedTasks: [],
    addedTasks: [],
  },
  tallest: {
    ...oralSwitch,
    invalidatesProgress: true,
    changeSummary: {
      ...oralSwitch.changeSummary,
      hasFinishedWorkThatStopsCounting: true,
    },
    removedTasks: [{ taskId: 'essay-old', title: 'Removed essay', hasProgress: true }],
  },
};

export const parseUpgradeOfferLabCase = (search: string): UpgradeOfferLabCase => {
  const value = new URLSearchParams(search).get('case');
  return (UPGRADE_OFFER_LAB_CASES as readonly string[]).includes(value ?? '')
    ? value as UpgradeOfferLabCase
    : 'oral-switch';
};
